module.exports = __webpack_public_path__ + "static/media/Manuela Escala.8ee659c0.png";